import * as ko from 'knockout';
import { WeekBase } from '../../shared/models/week-base';
import { Series } from '../../shared/models/series';
import type { IGame } from '../../shared/interfaces/IGame';
import { Enumerable } from '../../shared/linq';

/**
 * NHL Week.
 * - Initializes a concrete Series observable array (not ISeries interface).
 * - GamesComputed uses simple ascending sort (same as base).
 */
export class NhlWeek extends WeekBase {
  // Typed as KnockoutObservableArray<Series> for direct Series access in SchedulePicker
  override Series: KnockoutObservableArray<Series>;

  constructor(Division: string) {
    super(Division);
    // Re-initialize as concrete Series type (base initializes as ISeries)
    this.Series = ko.observableArray<Series>([]);
  }

  protected override createGamesComputed(): KnockoutObservable<IGame>[] {
    return Enumerable.From(this.games())
      .OrderBy((p: KnockoutObservable<IGame> | IGame) => {
        if (typeof p === 'function') {
          return (p as KnockoutObservable<IGame>)().SortOrder();
        }
        return (p as IGame).SortOrder();
      })
      .ThenBy((p: KnockoutObservable<IGame> | IGame) => {
        if (typeof p === 'function') {
          return (p as KnockoutObservable<IGame>)().home().TeamAbbreviation;
        }
        return (p as IGame).home().TeamAbbreviation;
      })
      .ToArray() as KnockoutObservable<IGame>[];
  }
}
